// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.history.familyhealthhistory.CreateFamilyHealthHistoryReviewSetRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateFamilyHealthHistoryReviewSetRequest extends GandalfModelBase {

	@GandalfValidator({ sizeString: { message: 'Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfConstantDecorator(constants.FamilyHealthHistoryConditionType)
	@GandalfProperty({ designType: constants.FamilyHealthHistoryConditionType })
	conditionType!: constants.FamilyHealthHistoryConditionType | null;

	@GandalfProperty({ designType: Number })
	encounterId!: number | null;

	@GandalfArray(Number)
	familyHealthHistoryIds!: number[] | null;

	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

}
